import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const authApi = {
    login(credentials) {
        return httpClient.post(API_ROUTES.member_login, credentials)
    },

    updatePassword(formData) {
        return httpClient.post(API_ROUTES.auth_updatePassword, formData)
    },

    getAuditMembers() {
        return httpClient.get(API_ROUTES.auth_userInfoList)
    },

    auditAllImages(formData) {
        return httpClient.post(API_ROUTES.auth_uploadAllImages, formData)
    },

    auditImage(payload) {
        return httpClient.post(API_ROUTES.auth_auditMemberImage, payload)
    },

    auditMemberLevel(formData) {
        return httpClient.post(API_ROUTES.auth_auditMemberLevel, formData)
    },

    updateDefaultPosition(memberId, type, position) {
        return httpClient.post(API_ROUTES.auth_updateDefaultLocation, null, {
            params: { memberId, type, position },
        })
    },
}
